module.exports = __webpack_public_path__ + "img/img_32389_0_308.7682151e.png";